import { useCallback } from 'react';
import type { SelectProps } from '../textInput/TextInput';
import TextInput from '../textInput/TextInput';
import GaTracker from '../../utils/GaTracker/GaTracker';

interface IProps extends Omit<SelectProps, 'select'> {
  action: string;
}

export default function Select({ onChange: propsOnChange, action, ...props }: IProps) {
  const onChange = useCallback(
    (value: string) => {
      GaTracker.trackEvent({
        category: 'Select',
        action: `select-${action}`,
        label: props.label,
      });
      propsOnChange(value);
    },
    [propsOnChange, action, props.label],
  );
  return <TextInput {...props} onChange={onChange} select />;
}
